import { Edit, SimpleForm } from "@/components/admin"
import { Button } from "@/components/ui/button"
import { Card, CardHeader } from "@/components/ui/card"
import { Tabs, TabsList } from "@/components/ui/tabs"
import { transformUserData } from "@/lib/utils/ra.supabase.conf"
import { Settings2 } from "lucide-react"
import { AccountTab, AccountTrigger } from "./components/edit-users-account"
import { PersonalTab, PersonalTrigger } from "./components/edit-users-personal"
import { FullNameField } from "./components/FullNameField"

const UserEdit = (): React.ReactElement => {
  return (
    <Edit title={false} actions={false} transform={transformUserData}>
      <SimpleForm>
        <Card className="p-0 m-0 bg-secondary border-0">
          <CardHeader className="flex items-center justify-between p-1 px-2">
            <FullNameField />
            <div className="flex items-center">
              <Button disabled variant="ghost" size="icon" className="">
                <Settings2 className="size-4 " />
              </Button>
            </div>
          </CardHeader>
        </Card>
        <Tabs defaultValue="personal">
          <TabsList className="grid w-full grid-cols-2 h-fit bg-secondary ">
            <PersonalTrigger />
            <AccountTrigger />
          </TabsList>
          <PersonalTab />
          <AccountTab />
        </Tabs>
      </SimpleForm>
    </Edit>
  )
}

export default UserEdit
